import * as React from "react";
const SvgArrowTriangleDown = (props) => /* @__PURE__ */ React.createElement("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 60 60", ...props }, /* @__PURE__ */ React.createElement("path", { id: "b", d: "M30,45L0,15h60l-30,30Z", fill: "currentColor" }));
export default SvgArrowTriangleDown;
